import React from "react";
import {withStyles,Typography,Card,CardActions,CardContent,FormControl} from "@material-ui/core";
import {CustomInput,Button,LoadingSpinner,ErrorNotification,InfoNotification, IconButton} from "../../components"
import validate from '../../actions/validateWrapper'
import { withFirebase,firebaseConnect,isEmpty,isLoaded} from 'react-redux-firebase'
import { connect } from 'react-redux';
import {compose} from 'redux'


class PasswordResetPage extends React.Component{

   
    state={
        email:"",
        emailError:"",
        error:null,
        info:null,
        isLoading:false
    }

    constructor(props){
        super(props)
        this.passwordreset = this.passwordreset.bind(this)
    }
    

    passwordreset(event){
        event.preventDefault();
        const {email} = this.state;
        const {firebase,route} = this.props

        const emailError = validate('email', this.state.email)

        this.setState({
            emailError: emailError,
          })

          if (!emailError) {
        this.setState({isLoading:true,error:null,info:null})
        console.log("email state:",this.state);
        console.log(`${email}`);
        firebase.auth().sendPasswordResetEmail(
            email
        ).then(()=>{
            // this.setState({isLoading:false})
            this.setState({info:"Email has been sent",isLoading:false})
        }).catch((error)=>{
            this.setState({error:error.message,isLoading:false})
        })
    }
    }




    render(){
        const { classes,auth,route } = this.props;
        const {isLoading,error,info} = this.state
        
            return(
                <div className={classes.content}>

                    <Card className={classes.loginCard}>
                        <form onSubmit={this.passwordreset}>
                        <Typography variant="title" color="inherit">
                            Password Reset Link
                        </Typography>

                        <CardContent>
                            <Typography variant="subheading" color="inherit">
                                Enter Email to send Password reset link
                            </Typography>
                            <CustomInput
                                labelText="Email"

                                inputProps={
                                    {
                                        autoFocus:true,
                                        type:"email",
                                        onChange: (event)=>{this.setState({email:event.target.value})},
                                        onBlur:() => {
                                            this.setState({
                                                emailError: validate('email', this.state.email)
                                            })
                                        }
                                    }
                                }

                                formControlProps={{
                                    fullWidth: true

                                }}
                                error={this.state.emailError}
                            />
                        </CardContent>
                        <CardActions className={classes.cardActions}>
                            {!isLoading?
                                <Button color="primary" type="submit">
                                    Submit
                                </Button>:                            <LoadingSpinner/>
                            }

                        </CardActions>
                        </form>
                    </Card>
                      {info&&
                    <InfoNotification message={info} />
                    } 
                    {error&&
                    <ErrorNotification message={error} />
                    }
                </div>
            )
        }
}
const styles = {
    content:{
        paddingTop:200,
        maxWidth:400,
        margin:"auto",
        flexGrow:0.9,
        justifyContent:"center",
        textAlign:"center",
        padding:20
    },
    cardActions:{
        justifyContent:"flex-end"
    },
    cardcenter:{
        justifyContent:"center"
    },
    loginCard:{
        paddingTop:20
    }

};

export default withFirebase(withStyles(styles)(PasswordResetPage));




// WEBPACK FOOTER //
// ./src/views/PasswordReset/PasswordReset.jsx